import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
  en: {
    $vuetify: {
      dataTable: {
        rowsPerPageText: 'Items per page:'
      },
      dataIterator: {
        pageText: '{0}-{1} z {2}',
        rowsPerPageAll: 'Vše'
      }
    }
  },
  cs: {
    $vuetify: {
      dataTable: {
        rowsPerPageText: 'Řádek na stránku:'
      },
      dataIterator: {
        pageText: '{0}-{1} z {2}',
        rowsPerPageAll: 'Vše'
      }
    }
  }
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'cs', // set locale
  messages // set locale messages
})

Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  theme: {
    primary: '#09a24a',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
})
